<template>
  <div class="container-fluid">
    <div class="row align-items-center my-3">
      <div class="col">
        <label
          for="col-sm-2 col-12 col-form-label text-center"
          class="form-label"
          >Wybierz grupę produktów:</label
        >
      </div>
      <div class="col-sm-3">
        <multiselect
          v-model="localSelectedGroup"
          :options="itemsGrpCod"
          :multiple="false"
          :close-on-select="true"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Wybierz grupę"
          label="ItmsGrpNam"
          track-by="ItmsGrpCod"
        ></multiselect>
      </div>
      <div class="col-sm-3">
        <multiselect
          v-model="localSelectedAssortmentGroup"
          :options="filteredAssortmentGroups"
          :multiple="false"
          :close-on-select="true"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Wybierz grupę asortymentową"
          label="Name"
          track-by="AssortmentCode"
          v-if="localSelectedGroup"
        ></multiselect>
      </div>
      <div class="col-sm-3">
        <multiselect
          v-model="localSelectedSubGroup"
          :options="filteredSubGroups"
          :multiple="false"
          :close-on-select="true"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Wybierz podgrupę asortymentową"
          label="Name"
          track-by="AssortmentCode"
          v-if="localSelectedAssortmentGroup"
        ></multiselect>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "ProductGroupSelect",
  components: {
    Multiselect,
  },
  data() {
    return {
      localSelectedGroup: null,
      localSelectedAssortmentGroup: null,
      localSelectedSubGroup: null,
    };
  },
  computed: {
    ...mapState("products", [
      "itemsGrpCod",
      "assCod",
      "subGroupCod",
      "selectedGroup",
      "selectedAssortmentGroup",
      "selectedSubGroup",
    ]),
    filteredAssortmentGroups() {
      if (!this.localSelectedGroup) return [];
      return this.assCod.filter(
        (item) => item.ItmsGrpCod === this.localSelectedGroup.ItmsGrpCod
      );
    },
    filteredSubGroups() {
      if (!this.localSelectedAssortmentGroup) return [];
      return this.subGroupCod.filter(
        (item) =>
          item.U_ASOR === this.localSelectedAssortmentGroup.AssortmentCode
      );
    },
  },
  watch: {
    selectedGroup(newVal) {
      this.localSelectedGroup = newVal;
    },
    selectedAssortmentGroup(newVal) {
      this.localSelectedAssortmentGroup = newVal;
    },
    selectedSubGroup(newVal) {
      this.localSelectedSubGroup = newVal;
    },
    localSelectedGroup(newVal) {
      this.setSelectedGroup(newVal);
      this.localSelectedAssortmentGroup = null;
      this.localSelectedSubGroup = null;
    },
    localSelectedAssortmentGroup(newVal) {
      this.setSelectedAssortmentGroup(newVal);
      this.localSelectedSubGroup = null;
    },
    localSelectedSubGroup(newVal) {
      this.setSelectedSubGroup(newVal);
    },
  },
  methods: {
    ...mapMutations("products", [
      "setSelectedGroup",
      "setSelectedAssortmentGroup",
      "setSelectedSubGroup",
    ]),
    onSelect(selected) {
      this.setSelectedGroup(selected);
      // this.setSelectedAssortmentGroup(null);
      // this.setSelectedSubGroup(null);
    },
    onSelectAssortmentCode(selected) {
      this.setSelectedAssortmentGroup(selected);
      // this.setSelectedSubGroup(null);
    },
    onSelectSubGroupCode(selected) {
      this.setSelectedSubGroup(selected);
    },
    // onSelect(selected) {
    //   this.$emit("group-selected", selected);
    // },
    // onSelectAssortmentCode(selected) {
    //   this.$emit("assortment-group-selected", selected);
    // },
    // onSelectSubGroupCode(selected) {
    //   this.$emit("sub-group-selected", selected);
    // },
  },
  created() {
    this.localSelectedGroup = this.selectedGroup;
    this.localSelectedAssortmentGroup = this.selectedAssortmentGroup;
    this.localSelectedSubGroup = this.selectedSubGroup;
  },
};
</script>

<style scoped>
.multiselect {
  /* width: 300px; */
}
</style>
